import React, { useState, useRef } from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const PullToRefresh = ({ children, onRefresh, threshold = 100 }) => {
  const [isRefreshing, setIsRefreshing] = useState(false)
  const [pullDistance, setPullDistance] = useState(0)
  const [startY, setStartY] = useState(0)
  const containerRef = useRef(null)

  const handleTouchStart = (e) => {
    if (containerRef.current.scrollTop === 0) {
      setStartY(e.touches[0].clientY)
    }
  }

  const handleTouchMove = (e) => {
    if (startY === 0 || containerRef.current.scrollTop > 0) return

    const currentY = e.touches[0].clientY
    const distance = currentY - startY

    if (distance > 0) {
      e.preventDefault()
      setPullDistance(Math.min(distance, threshold * 1.5))
    }
  }

  const handleTouchEnd = async () => {
    if (pullDistance >= threshold && !isRefreshing) {
      setIsRefreshing(true)
      try {
        await onRefresh()
      } finally {
        setIsRefreshing(false)
      }
    }
    
    setPullDistance(0)
    setStartY(0)
  }

  return (
    <Box
      ref={containerRef}
      sx={{
        height: '100%',
        overflow: 'auto',
        position: 'relative',
      }}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      {(pullDistance > 0 || isRefreshing) && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: Math.max(pullDistance, isRefreshing ? 80 : 0),
            backgroundColor: 'background.default',
            zIndex: 1000,
            transition: isRefreshing ? 'height 0.3s ease' : 'none',
          }}
        >
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ mt: 1 }}>
            Refreshing data...
          </Typography>
        </Box>
      )}
      
      <Box sx={{ paddingTop: isRefreshing ? '80px' : '0' }}>
        {children}
      </Box>
    </Box>
  )
}

export default PullToRefresh